<new-flowbanner [showPromo]="true"></new-flowbanner>
<div class="pt-5 py-lg-5 feedback-container">
    <div class="row justify-content-center me-0">
        <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
            <img class="feedback-image" src="./assets/img/CotizacionPausa.png" width="500" height="320" priority
                alt="Ilustración de dos manos estrechándose en señal de acuerdo." />

            <h2 class="feedback-title mb-4">Cotización en pausa</h2>
            <p class="feedback-subtitle mb-4">
                Has estado inactivo por un tiempo. <br>
                Si necesitas ayuda, no dudes en contactarnos.
            </p>

            <button type="button" class="btn btn-primary btn-lg rounded-pill sura-feedback-btn mt-lg-0 mt-3 mb-3" (click)="goBack()">
                Seguir en línea
            </button>
            <button type="button" class="btn btn-primary btn-lg rounded-pill sura-feedback-btn sura-feedback-btn--white mt-lg-0 mt-3 mb-5" (click)="contactarAsesor()">
                Contactar asesor
            </button>
        </div>
    </div>
</div>

<app-footer-app></app-footer-app>